'use client';

import './home-mobile.scss';
import ContactButton from '@/components/ContactButton';

const REACH_BUTTON_FONT_SIZE = 12;

export default function Reach() {
  return (
    <div className='reach-slide'>
      <p className='text-gray'>{`< Reach >`}</p>
      <p>
        {'195 Pearl’s Hill Terrace #03-76 Singapore 168976'}
      </p>
      <p className={'text-gray'}>{'< or >'}</p>
      <div style={{marginLeft: '-40px', marginTop: '5px'}}>
        <ContactButton fontSize={REACH_BUTTON_FONT_SIZE} />
      </div>
    </div>
  )
}